var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('div',{staticClass:"custom-tooltip"},[_c('strong',[_vm._v(" "+_vm._s(_vm.pesan)+" ")])]):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }